import '@babel/polyfill';
import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;
const defaultTitle = 'EPD Archiv';
const titleAndStorageReady = async (to: any, from: any, next: any) => {
  document.title = to.meta.title || defaultTitle; // set page titles
  await (store as any).restored; // fix missing type extension by plugin
  next();
};

router.beforeEach(titleAndStorageReady);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
